import { createApp } from 'vue'
import App from '@/page/vue/2026/event/signup.vue'
import Antd from 'ant-design-vue'
import Vant from 'vant'
import Design from '@q/design';
import initShare from '@/utils/wxShare.js'
import tongji from '@/utils/tongji.js'; //引入统计
import 'ant-design-vue/dist/antd.css'
import '@q/design/dist/design.css';

import 'animate.css'
import '@/styles/index.scss'
import 'vant/lib/index.css'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import Qapm from '@q/qapm';
Qapm('init', {
    appKey: 'isc',
    env: import.meta.env.MODE,
    ratio: 100,
});

tongji(); //统计
initShare({
    title: 'ISC.AI 2026议题征集',
    desc: '即刻参与ISC.AI 2026议题征集，生成你的专属思想海报，引爆行业关注！',
    imgUrl: 'https://p1.ssl.qhimg.com/t01c773b371e5596287.png',
    link: window.location.href
})

const app = createApp(App)
app.use(Antd)
app.use(Vant)
app.use(Design);
app.use(ElementPlus)

app.mount('#app')
